<template>
  <div
    @keydown.down="focusNextListItem($event)"
    @keydown.up="focusPreviousListItem($event)"
    class="Inspiration-filter-content"
    ref="inspirationFiltersContent"
  >
    <div class="Inspiration-filter-content__filters">
      <ux-atoms-form-field-set :legend="legend" legend-is-s-r-only v-if="filtersModel" variant="default">
        <template :key="filtersModel[index].id" v-for="(filter, index) in filtersModel">
          <ux-atoms-form-checkbox-input class="Booking-funnel-credit-card__checkbox" v-model="filtersModel[index].value">
            {{ filter.label }}
          </ux-atoms-form-checkbox-input>
        </template>
      </ux-atoms-form-field-set>
    </div>
    <div class="Inspiration-filter-content__actions">
      <ux-atoms-button
        :label="$t('ux.molecules.inspirationFilterContent.cancel')"
        @click="cancelFilters"
        class="Inspiration-filter-content__cancel"
        variant="link"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { getFocusableElements, getNextFocusableElement, getPreviousFocusableElement } from '~/helpers/accessibility';

export type FiltersContent = {
  id?: null | string;
  label?: string;
  value?: boolean;
};

export interface InspirationFilterContentProps {
  filters?: FiltersContent[];
  legend?: string;
}

const props = defineProps<InspirationFilterContentProps>();
const emit = defineEmits(['inspiration-filter-content::filter-update']);

const inspirationFiltersContent = ref();
const filtersModel = ref<FiltersContent[]>(props.filters ? [...props.filters] : []);
const focusableListElements = ref<HTMLElement[]>();

watch(
  () => props.filters,
  (newFilters) => {
    if (newFilters) {
      filtersModel.value = [...newFilters];
    }
  },
  { deep: true, immediate: true }
);

const emitFilters = useDebounceFn(() => {
  emit('inspiration-filter-content::filter-update', [...filtersModel.value]);
}, 100);

const getListFocusableElements = () => {
  focusableListElements.value = getFocusableElements(inspirationFiltersContent.value) as HTMLElement[];
};

const focusPreviousListItem = (e: Event) => {
  e.preventDefault();
  if (e?.target) {
    const previousEl = getPreviousFocusableElement(e.target as HTMLElement, focusableListElements.value as HTMLElement[]);
    previousEl.focus();
  }
};

const focusNextListItem = (e: Event) => {
  e.preventDefault();
  if (e?.target) {
    const nextEl = getNextFocusableElement(e.target as HTMLElement, focusableListElements.value as HTMLElement[]);
    nextEl?.focus();
  }
};

onMounted(() => {
  getListFocusableElements();
});

watch(
  () => filtersModel.value.map((filter) => filter.value),
  () => {
    emitFilters();
  },
  { deep: true }
);

const cancelFilters = () => {
  filtersModel.value.forEach((filter) => (filter.value = false));
  emitFilters();
};
</script>
<style lang="scss" scoped>
@use 'InspirationFilterContent.scss';
</style>
